<template>
	<div class="container-wrap rtr_pay-deposit">
		<div class="container-box">
			<div class="card mb_10">
				<h3 id="selectAsset" class="title">
					<img
						:src="iconSendAssetsTitle"
						alt=""
						style="width: 20px; height: 20px"
					/>
					{{ $t('rtr_pay-deposit.title1') }}
				</h3>
			</div>
			<div class="card type1 mb_0 pt_40 pb_40">
				<div class="card_inner">
					<div :class="[isMobile ? 'd_block' : 'd_flex']">
						<div :class="[isMobile ? 'mb_40' : '']">
							<AccountPicker @changeAccount="getAccountInfo"></AccountPicker>

							<div v-if="selectedAccountInfo" class="bg_blue_box">
								<div class="d_flex justify_between">
									<div class="asset_box">
										<span
											:class="[selectedAccountInfo?.asset_code, 'medium']"
										></span>
										<div>
											<p :class="['code', isMobile ? 'mb_0' : 'mb_4']">
												{{ selectedAccountInfo?.asset_code }}
											</p>
											<p class="name">{{ selectedAccountInfo?.asset_title }}</p>
										</div>
									</div>
									<div class="balance_area">
										<div class="quantity fc_white mr_5">
											{{ selectedAccountInfo?.balance }}
										</div>
										<span class="currency fc_white">{{
											selectedAccountInfo?.asset_code
										}}</span>
									</div>
								</div>
							</div>
						</div>
						<div>
							<h3 id="selectWay" class="title mb_20">
								{{ $t('rtr_pay-deposit.title2') }}
							</h3>
							<div class="mb_20">
								<ul
									:class="[
										'withdraw',
										'mb_20',
										'tac',
										isMobile ? 'd_block' : 'd_flex',
									]"
								>
									<li :class="[isMobile ? 'mb_20' : 'mr_20']">
										<input
											type="radio"
											id="way1"
											class="radio_way"
											v-model="selectedWay"
											name="selectWay"
											value="way1"
											@click="selectWay"
										/>
										<label for="way1" class="w100 type_01">
											<span class="coin_name">{{
												$t('rtr_pay-deposit.text1')
											}}</span>
										</label>
									</li>
									<li
										:class="[isMobile ? 'mb_20' : 'mr_20']"
										v-if="
											!selectedAccountInfo ||
											selectedAccountInfo?.code !== 'JPYS'
										"
									>
										<input
											type="radio"
											id="way2"
											class="radio_way"
											v-model="selectedWay"
											name="selectWay"
											value="way2"
											@click="selectWay"
										/>
										<label for="way2" class="w100 type_01">
											<span class="coin_name">
												{{ $t('rtr_pay-deposit.text2') }}
											</span>
										</label>
									</li>
									<li class="">
										<input
											type="radio"
											id="way3"
											class="radio_way"
											v-model="selectedWay"
											name="selectWay"
											value="way3"
											@click="selectWay"
										/>
										<label for="way3" class="w100 type_01">
											<span class="coin_name">{{
												$t('rtr_pay-deposit.text3')
											}}</span>
										</label>
									</li>
								</ul>

								<div class="">
									<div v-show="showTab === 'way1'">
										<div class="mb_20">
											<h3 class="title mb_10">
												{{ $t('rtr_pay-deposit.text4') }}
											</h3>
											<div class="es_search">
												<input
													type="text"
													:value="selectedAccountInfo?.account_number"
													readonly
												/>
											</div>
										</div>
									</div>

									<div v-show="showTab === 'way2'">
										<div class="mb_20">
											<h3 class="title mb_10">
												{{ $t('rtr_pay-deposit.text5') }}
											</h3>
											<div class="es_search">
												<input
													type="text"
													:value="selectedAccountInfo?.address"
													readonly
												/>
											</div>
										</div>
									</div>
									<div v-show="showTab === 'way3'">
										<invoice
											ref="invoice"
											:assetSeq="selectedAccountInfo?.asset_seq"
											@change="setInvoiceData"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="button_area">
					<button class="button_primary" @click="toDashboard">
						{{ $t('button.cancel') }}
					</button>
					<button class="button_bg_blue" @click="onRequestHandler">
						{{ $t('button.request') }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<ModalMessage v-if="messageModal">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div
			v-if="selectedWay === 'way3' && status === 'check'"
			class="button_area"
		>
			<button class="" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div
			v-else-if="selectedWay === 'way3' && status === 'success'"
			class="button_area"
		>
			<button @click="messageModalCloseHandler('close')">
				{{ $t('button.close') }}
			</button>
			<button class="" @click="messageModalCloseHandler">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-else class="button_area">
			<button class="" @click="messageModalCloseHandler">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
	<ModalMessage
		v-if="requestCheckModal"
		@closeModal="requestCheckModal = false"
	>
		<div class="tac modal_invoice pt_30">
			<p class="mb_16 fs_20 email">{{ invoiceData?.email }}</p>
			<div class="asset_box justify_center mb_20">
				<span :class="[selectedAccountInfo.asset_code, 'small']"></span>
				<p class="code mr_4 mb_0">{{ selectedAccountInfo.asset_code }}</p>
				<p class="name">{{ selectedAccountInfo.asset_title }}</p>
			</div>
			<div class="num_unit_w mb_15">
				<p class="num mr_4">{{ invoiceData?.amount }}</p>
				<p class="unit">{{ selectedAccountInfo?.asset_code }}</p>
			</div>
			<p class="mb_15">{{ invoiceData?.title }}</p>
			<!--			<p class="mb_15">-->
			<!--				{{ $dayjs(invoiceData.endDate).format('YYYY.MM.DD') }}-->
			<!--			</p>-->
			<p class="text mb_50">{{ $t('rtr_pay-invoice.text1') }}</p>
		</div>
		<div class="button_area">
			<button class="" @click="requestCheckModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="" @click="sendInvoice">
				{{ $t('button.request') }}
			</button>
		</div>
	</ModalMessage>
	<ModalView v-if="shareModal" @closeModal="shareModal = false">
		<div class="qr_area pt_20">
			<p>{{ shareModalData.title }}</p>
			<div class="qr_image_wrap">
				<Qrcode
					id="qr"
					:color="{ dark: '#000000ff', light: '#ffffffff' }"
					type="image/png"
					:quality="1"
					:margin="1"
					:value="shareModalData.value"
					class="w100"
				/>
			</div>
			<!-- <div class="qr_download">
				<a @click="qrDownload"
					><img
						src="@/assets/images/icon/download.png"
						alt="download button image"
					/>
					download</a
				>
			</div> -->
			<p class="address mt_10 mb_40">{{ shareModalData.value }}</p>
			<button class="button_bg_blue" @click="copyShareModalValue">
				{{ $t('account-wallet.btn_copy') }}
			</button>
		</div>
	</ModalView>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import AccountPicker from '@/components/AccountPicker.vue';
import ModalView from '@/components/Layout/ModalView';
import ModalMessage from '@/components/Layout/ModalMessage';
import Invoice from '@/components/User/Pay/Invoice';
import { mapGetters } from 'vuex';
import { Navigation } from 'swiper';
import useClipboard from 'vue-clipboard3';
import Tutorial from '@/components/Tutorial';
import Cookies from 'js-cookie';
import { createInvoice } from '@/api/deposit';
import { commonError } from '@/common/dialog';
import iconSendAssetsTitle from '@/assets/images/v2/icon/icon-send-assets-title.svg';

export default {
	name: 'deposit',
	components: {
		AccountPicker,
		ModalView,
		ModalMessage,
		Tutorial,
		Invoice,
	},
	props: {
		seq: {
			type: Number,
		},
	},
	data() {
		return {
			modules: [Navigation],
			showTab: null,
			selectedAccountSeq: 0,
			selectedWay: '',
			checked: false,
			messageModal: false,
			requestCheckModal: false,
			modalIcon: 'error',
			modalStatusMessage: '',
			sendAmount: null,
			shareModal: false,
			shareModalData: {
				title: '',
				value: '',
			},
			tour: null,
			showTutorial: false,
			invoiceData: {},
			status: '',
			isMobile: false,
			iconSendAssetsTitle,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('account', ['own_assets_group']),
		...mapGetters('assets', ['assets']),
		...mapGetters('auth', ['member_info']),
		...mapGetters('lang', ['lang']),

		ownAssetsItems() {
			let data = [];
			const group = Object.keys(this.own_assets_group).map(Number);
			this.assets.forEach(asset_item => {
				if (group.includes(asset_item.seq)) data.push(asset_item);
			});
			return data;
		},
		selectedAccountInfo() {
			return this.accounts.find(account => {
				return account.seq === parseInt(this.selectedAccountSeq);
			});
		},
	},
	watch: {
		selectedAccountInfo(info) {
			if (info.code === 'JPYS') {
				this.selectedWay = 'way1';
				this.showTab = 'way1';
			} else {
				this.selectedWay = 'way1';
				this.showTab = 'way1';
			}
		},
	},
	methods: {
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
		selectWay(e) {
			if (!this.selectedAccountInfo?.seq) {
				e.target.checked = false;
				this.modalIcon = 'error';
				this.modalStatusMessage = this.$t('modal.message.select_asset');
				this.messageModal = true;
				return;
			}
			this.showTab = e.target.id;
		},
		getAccountInfo(accountSeq) {
			this.selectedAccountSeq = accountSeq;
		},
		toDashboard() {
			this.$router.push({ name: 'auth-dashboard' });
		},
		validations() {
			if (!this.selectedAccountInfo) {
				this.modalStatusMessage = this.$t('modal.message.select_asset');
				return false;
			}
			if (!this.selectedWay) {
				this.modalStatusMessage = this.$t('modal.message.select_way');
				return false;
			}
			if (this.selectedWay === 'way2') {
				if (!this.selectedAccountInfo.address) {
					this.modalStatusMessage = this.$t('rtr_pay-deposit.text6');
					return false;
				}
			}
			if (this.selectedWay === 'way3') {
				if (!this.invoiceData.email) {
					this.modalStatusMessage = this.$t('rtr_pay-deposit.email');
					return false;
				}
				if (!this.invoiceData.title) {
					this.modalStatusMessage = this.$t('rtr_pay-deposit.item');
					return false;
				}
				if (!this.invoiceData.amount) {
					this.modalStatusMessage = this.$t('rtr_pay-deposit.amount');
					return false;
				}
				// if (!this.invoiceData.endDate) {
				// 	this.modalStatusMessage = '지불기한을 입력해 주세요.';
				// 	return false;
				// }
			}
			return true;
		},
		onRequestHandler() {
			if (this.selectedWay === 'way3') {
				if (!this.validations()) {
					this.status = 'check';
					this.modalIcon = 'error';
					this.messageModal = true;
					return;
				}
				this.requestCheckModal = true;
			} else {
				this.onShare();
			}
		},
		onShare() {
			if (!this.validations()) {
				this.modalIcon = 'error';
				this.messageModal = true;
				return;
			}
			if (this.selectedWay === 'way1') {
				this.shareModalData.title = this.$t('rtr_pay-deposit.my_account');
				this.shareModalData.value = this.selectedAccountInfo.account_number;
			}
			if (this.selectedWay === 'way2') {
				this.shareModalData.title = this.$t('rtr_pay-deposit.my_wallet');
				this.shareModalData.value = this.selectedAccountInfo.address;
			}
			this.shareModal = true;
		},
		async sendInvoice() {
			this.requestCheckModal = false;
			const params = {
				account_seq: this.selectedAccountSeq,
				title: this.invoiceData.title,
				applicant_email_address: this.invoiceData.email,
				net_amount: this.invoiceData.amount,
			};
			await createInvoice(params)
				.then(() => {
					this.status = 'success';
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$('rtr_pay-deposit.success');
					this.messageModal = true;
				})
				.catch(commonError);
		},
		setInvoiceData(data) {
			this.invoiceData = data;
		},
		qrDownload() {
			const dataUrl = document.getElementById('qr').src;
			const link = document.createElement('a');
			link.href = dataUrl;
			link.download = 'qrcode';
			link.click();
		},
		copyShareModalValue() {
			try {
				useClipboard().toClipboard(this.shareModalData.value);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		tutorialHandler() {
			if (!Cookies.get(this.$route.name + '_tutorial')) {
				this.showTutorial = true;
			}
		},
		messageModalCloseHandler(type) {
			if (this.selectedWay === 'way3') {
				if (type === 'close') {
					this.messageModal = false;
					if (this.status === 'success') {
						this.status = '';
						this.$refs.invoice.initForm();
					}
				} else {
					this.$router.push({
						name: 'activity-invoice',
						query: { accountSeq: this.selectedAccountSeq },
					});
				}
			} else {
				this.messageModal = false;
			}
		},
	},
	created() {
		if (this.$route.query.accountSeq) {
			this.selectedAccountSeq = this.$route.query.accountSeq;
		}
	},
	mounted() {
		this.tutorialHandler();
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
};
</script>
<style scoped></style>
